import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'

/**
 * @typedef {Object} OrderAddress
 *
 * @property {Id}                   [addressId]           - Address id for destination, optional field.
 * @property {string}               [city]                - City name of address.
 * @property {string}               [countryCode]         - Country code of address, such as DE, FR, US.
 * @property {string}               [federalState]        - Federal state of address.
 * @property {LocationDescription}  [locationDescription] - Reverse geocoded location description for the destination.
 * @property {string}               [mapcode]             - Map code of destination.
 * @property {Position}             [position]            - Destination geo position.
 * @property {string}               [street]              - Street of address.
 * @property {string}               [zip]                 - Zip of address.
 */
export const orderAddressPropType = PropTypes.shape({
    addressId: idPropType,
    city: PropTypes.string,
    countryCode: PropTypes.string,
    federalState: PropTypes.string,
    locationDescription: locationDescriptionPropType,
    mapcode: PropTypes.string,
    position: positionPropType,
    street: PropTypes.string,
    zip: PropTypes.string
})
